import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RangeDateControllerDirective} from "./range-date-controller.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [
    RangeDateControllerDirective
  ],
  exports: [
    RangeDateControllerDirective
  ]
})
export class RangeDateControllerModule {}
